import React from 'react';
import { Header24h34, NumberText, Statistics, StatisticsItem } from './styles';
import Spacer from '../shared/Spacer';
import { NumberElement, Plate, Container, Header, Text } from '../shared/ui/Page';
import pluralize from 'utils/pluralize';
import useUserData from 'hooks/useUserData';
import Banner from './banner';
import { useWebinarStatistics } from './useWebinarStatistics';
import { useGetWebinar } from './useWebinarStore';
import Schedule from './schedule';

const Component = () => {
  const userData = useUserData();
  const userId = userData!.id;
  const { data: statData } = useWebinarStatistics();
  const { loaded, activeTab, webinarsInMonth, months, getDowloadPath, setTab } = useGetWebinar(userId);

  return (
    <Container>
      <Header>Обучение учителей</Header>
      <Spacer size={24} />
      <Text style={{ paddingLeft: 24 }}>
        В целях развития профессиональных компетенций учителей на платформе Учи.ру
        <br /> регулярно проводятся вебинары с привлечением экспертов в сфере образования
      </Text>
      <Spacer size={40} />

      <Plate>
        <Header24h34>Суммарные показатели</Header24h34>
        <Spacer size={24} />
        <Statistics>
          <StatisticsItem>
            <div>
              <NumberElement>{statData.activated_teachers}</NumberElement>
              <span style={{ fontSize: 18, lineHeight: '24px', fontWeight: 700, marginLeft: 8 }}>
                {pluralize(statData.activated_teachers, 'учитель', 'учителя', 'учителей')}
              </span>
            </div>
            <Spacer size={8} />
            <NumberText>
              {pluralize(statData.activated_teachers, 'зарегистрировался', 'зарегистрировались')} на посещение вебинаров
            </NumberText>
          </StatisticsItem>
          <Spacer size={24} />
          <StatisticsItem>
            <div>
              <NumberElement>{statData.rewarded_teachers}</NumberElement>
              <span style={{ fontSize: 18, lineHeight: '24px', fontWeight: 700, marginLeft: 8 }}>
                {pluralize(statData.rewarded_teachers, 'учитель', 'учителя', 'учителей')}
              </span>
            </div>
            <Spacer size={8} />
            <NumberText>
              {pluralize(statData.rewarded_teachers, 'получил', 'получили')} сертификаты за просмотр вебинара
            </NumberText>
          </StatisticsItem>
        </Statistics>
      </Plate>
      <Spacer size={40} />
      <Banner link={getDowloadPath(userId, activeTab.id)} />
      <Spacer size={40} />
      <Schedule
        activeTab={activeTab}
        setTab={setTab}
        loaded={loaded}
        months={months}
        webinarsInMonth={webinarsInMonth}
      />
    </Container>
  );
};
export default Component;
